import { StarknetNetwork } from '../constants/networks'

export default function getSnNetworkDisplayName(network: StarknetNetwork) {
  if (network == StarknetNetwork.SNGOERLI) {
    return "Goerli"
  } else {
    return "Mainnet"
  }
}